import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { IconChevronRightSmall } from '~/ui/core/icons';

type PromptVersionLabelProps = {
    readonly previousVersion: number;
    readonly currentVersion: number;
};

export const PromptVersionLabel: FunctionComponent<PromptVersionLabelProps> = ({ previousVersion, currentVersion }) => {
    const translate = useTranslate();

    return (
        <div className="flex items-center gap-xxs text-xxs font-medium text-gray-700">
            <span>{translate('pages.job-architecture-v2.job-profile-version', { version: previousVersion })}</span>
            <IconChevronRightSmall size={10} />
            <span>{translate('pages.job-architecture-v2.job-profile-version', { version: currentVersion })}</span>
        </div>
    );
};
